<template>
  <div class="leaderInfo">
    <!-- 内容区 -->
    <div class="content">
      <div class="chanpincon">
        <div class="inner">
          <div class="childnav">
            <div class="desc">
              <img src="/statics/image/index/icon.png" alt />
              <span>{{cateact.title}}</span>
            </div>
            <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(item,index) in s_cates" :key="index" :name="item.id.toString()">
                <a href="javascript:scroll(0,0)" slot="label" v-if="item.title">{{item.title}}</a>
              </el-tab-pane>
              <!-- <el-tab-pane label="领导信息" name="one"></el-tab-pane>
              <el-tab-pane label="顾问团队" name="two"></el-tab-pane>-->
            </el-tabs>
          </div>
          <div class="news_right" v-if="activeName=='36'">
            <div class="gg_list">
              <!-- @click="toLd(36,item.article_id)" -->
              <div class="gg_item" v-for="(item,index) in article.articlelist" :key="index">
                <div class="pic">
                  <img :src="adddom(item.article_thumb)" alt />
                </div>
                <div class="ldcon">
                  <div class="name">
                    <div class="ming">
                      <span>{{item.article_title}}</span>
                    </div>
                    <div class="qian">
                      <!-- <span v-for="(itema,indexa) in 3" :key="indexa">衡水高新区党工委书记</span> -->
                      <span v-if="item.article_keyword">{{item.article_keyword}}</span>
                    </div>
                  </div>
                  <div
                    v-if="item.article_describe"
                    class="jianjie slht"
                    v-html="item.article_describe"
                  ></div>
                  <!-- <div class="jianjie slho">
                    简介：
                    <span>男，汉族，1973年1月出生，河北阜城县人，在职研究生工程硕士。1995年9月参加工作参加工作参加工作参加工作参加工作参加工作</span>
                  </div>
                  <div class="zhize slho">
                    职责：
                    <span>男，汉族，1973年1月出生，河北阜城县人，在职研究生工程硕士。1995年9月参加工作参加工作参加工作参加工作参加工作参加工作</span>
                  </div>
                  <div class="tel">
                    电话：
                    <span>0318-2880777</span>
                  </div>-->
                  <div class="ldbottom">
                    <span>发布时间：{{item.publish_at}}</span>
                    <span>发布人：{{item.admin_name}}</span>
                    <span>点击次数：{{item.hits}}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 分页 -->
            <div class="fenye clearfix">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pages.size"
                layout="prev, pager, next, jumper"
                :total="newsTotal"
                prev-text="上一页"
                next-text="下一页"
              ></el-pagination>
            </div>
          </div>
          <div class="news_right" v-if="activeName=='231'">
            <div class="gw_list">
              <div class="gw_item" v-for="(item,index) in guwenteam" :key="index">
                <span class="desc">{{item.scate_title}}：</span>
                <span
                  class="name"
                  v-for="(itema,indexa) in item.article"
                  :key="indexa"
                  @click="toInfo(itema.article_id)"
                >{{itema.article_title}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabPosition: "left", //导航对齐方式
      activeName: "",
      currentPage: 1, //当前页数
      pages: {
        page: 1,
        size: 10
      },
      newsTotal: 0, //总条数
      nowindex: "",
      cateact: { title: "" },
      s_cates: [], //二级分类
      article: { articlelist: [] },
      guwenteam: [],
      topvalue: ""
    };
  },
  created() {
    if (localStorage.getItem("topvalue")) {
      this.topvalue = localStorage.getItem("topvalue");
    }
    this.getNav();
  },
  methods: {
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    // 获取导航
    getNav() {
      this.nowindex = this.$route.query.index;
      var that = this;
      that.$api.index.catelist({}).then(function(res) {
        if (res.code == 200) {
          that.cateact = res.result.all_cate[that.nowindex];
          that.s_cates = res.result.all_cate[that.nowindex].s_cates;
          that.activeName = res.result.all_cate[
            that.nowindex
          ].s_cates[0].id.toString();
          if (that.$route.query.dhid) {
            that.activeName = that.$route.query.dhid.toString();
          }
          if (that.activeName == "36") {
            that.getArticlelist();
          } else if (that.activeName == "231") {
            that.getGuwenteam();
          }
        }
      });
    },
    // 两委领导
    getArticlelist() {
      var that = this;
      var ps = {
        // cate_id: 36,
        page: that.pages.page,
        size: that.pages.size
      };
      if (that.topvalue && that.topvalue != "") {
        ps.keyword = that.topvalue;
      } else {
        ps.keyword = "";
      }
      that.$api.index.leadarticlelist(ps).then(function(res) {
        // that.$api.index.articlelist(ps).then(function(res) {
        if (res.code == 200) {
          that.article = res.result;
          that.newsTotal = res.result.total * 1;
          if (that.article.articlelist.length == 0) {
            that.$message({
              message: "搜索结果为空！",
              type: "warning"
            });
          }
        }
      });
    },
    // 顾问团队
    getGuwenteam() {
      var that = this;
      that.$api.index.guwenteam({}).then(function(res) {
        if (res.code == 200) {
          that.guwenteam = res.result;
        }
      });
    },
    // 导航选中触发
    handleClick(tab, event) {
      localStorage.removeItem("topvalue");
      // this.topvalue = "";
      // this.$store.commit("setSouvalue", { val: false });
      // console.log(tab.name);
      this.activeName = tab.name;
      this.currentPage = 1; //当前页数
      this.pages.page = 1;
      if (this.activeName == "36") {
        this.getArticlelist();
      } else if (this.activeName == "231") {
        this.getGuwenteam();
      }
    },
    // 跳转到领导详情
    toLd(cate_id, id) {
      this.$router.push({
        // path: "/xqNews_detail",
        path: "/leaderInfo_detail",
        query: {
          cate_id: cate_id,
          id: id,
          index: this.nowindex
          // erId:this.activeName
        }
      });
    },
    // 页数改变时触发
    handleCurrentChange(val) {
      // console.log(val);
      this.pages.page = val;
      this.getArticlelist();
      $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
    },
    // 点击跳转到新区要闻详情
    toInfo(id) {
      this.$router.push({
        path: "/gw_detail",
        query: {
          id: id,
          index: this.nowindex
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      if (to.name != "leaderInfo") {
        localStorage.removeItem("topvalue");
        this.topvalue = "";
      }
      // console.log(to.name, from.name);
      if (from.name == "wz_map") {
        this.currentPage = 1; //当前页数
        this.pages.page = 1;
        this.getNav();
        this.nowindex = this.$route.query.index;
        $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
      } else {
        this.getNav();
      }
    }
  }
};
</script>

<style>
</style>